import { useCallback, useEffect, useState } from "react";
import { DashboardService } from "../../../../../services/dashboard";
import { KPI_CODES } from "../../../kpiCodes";

export const useFetchData = (
  date: string,
  getKpiByKey: (key: string, values: any) => any,
) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [data, setData] = useState<any>({});

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);

      const res: any = await DashboardService.fetchDashboardData({
        date,
        kpiCodes: [
          KPI_CODES.ACCOUNTS_BEGINNING_BALANCE,
          KPI_CODES.ACCOUNTS_INTEREST_RATE,
          KPI_CODES.ACCOUNTS_REGULAR_PAYMENT,
          KPI_CODES.ACCOUNTS_WITH_IMPOUNDS,
        ],
      });

      const interestRate = getKpiByKey(
        KPI_CODES.ACCOUNTS_INTEREST_RATE,
        res,
      )?.value;

      const values: any = {
        beginningBalance: getKpiByKey(KPI_CODES.ACCOUNTS_BEGINNING_BALANCE, res)
          ?.value,
        interestRate: interestRate ? interestRate / 100 : undefined,
        regularPayment: getKpiByKey(KPI_CODES.ACCOUNTS_REGULAR_PAYMENT, res)
          ?.value,
        accountsWithImpounds: getKpiByKey(KPI_CODES.ACCOUNTS_WITH_IMPOUNDS, res)
          ?.value,
      };

      setData(values);

      setIsLoading(false);
    } catch {
      setIsLoading(false);
    }
  }, [date, getKpiByKey]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { isLoading, data };
};
